export default __webpack_public_path__ + "static/media/seminar (5).c6d17cd2.JPG";